import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { BottomReadyButton } from "../../components/BottomReadyButton";
import { MdaiDivider } from "../../components/MdaiDivider";

export function NoEvent() {
  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{ height: { lg: 868 }, textAlign: "center" }}
      py={10}
    >
      <Typography variant="h2">Events coming soon</Typography>
      <Typography variant="h4">
        We’re so excited to connect and grow alongside with our dev community
      </Typography>
      <Typography variant="h4">Come back soon to view our schedule</Typography>
      <MdaiDivider />
      <BottomReadyButton />
      <div />
    </Stack>
  );
}
